import React from "react";
import { MuiOtpInput } from "mui-one-time-password-input";
import { FormHelperText, useTheme } from "@mui/material";
import "./style.css";

const OTPInput = ({ value = "", onChange = null, error = null, onBlur = null, helperText = null }) => {
    const [otp, setOtp] = React.useState("");

    const theme = useTheme();

    const otpHandleChange = (newValue) => {
        setOtp(newValue);
        onChange(newValue);
    };

    return (
        <>
            <MuiOtpInput
                TextFieldsProps={(index) => ({
                    variant: "outlined",
                    color: "primary",
                    error,
                    type: "number",
                    // onBlur,
                    inputProps: {
                        "aria-label": `otp text input ${index + 1}`,
                        className: "mui-otp-text-input",
                    },
                })}
                width={"60%"}
                autoFocus={true}
                minWidth={"4rem"}
                length={6}
                // minHeight={'4rem'}

                value={value ? value : otp}
                onChange={otpHandleChange}
                sx={{
                    // colorSecondary

                    width: {
                        sm: "100%",
                        md: "70%",
                    },
                    [theme.breakpoints.down("sm")]: {
                        "& .MuiInputBase-input.MuiOutlinedInput-input": {
                            padding: "0",
                            height: "3rem",
                        },
                    },
                }}
            />
            {error && <FormHelperText error>{helperText || "OTP is required."}</FormHelperText>}
        </>
    );
};

export default OTPInput;
